"use client";

// src/components/default/upload.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var UploadIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `UploadIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `UploadIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M5.75034 15.5833C5.375 15.5833 5.05887 15.4538 4.80192 15.1947C4.54498 14.9357 4.4165 14.6186 4.4165 14.2435V13.5256C4.4165 13.3719 4.46793 13.2431 4.57077 13.1395C4.67362 13.0358 4.80129 12.9839 4.95377 12.9839C5.10627 12.9839 5.23541 13.0358 5.34117 13.1395C5.44693 13.2431 5.49982 13.3719 5.49982 13.5256V14.2435C5.49982 14.3076 5.52652 14.3664 5.57994 14.4198C5.63337 14.4733 5.69214 14.5 5.75625 14.5H14.2434C14.3075 14.5 14.3663 14.4733 14.4197 14.4198C14.4731 14.3664 14.4998 14.3076 14.4998 14.2435V13.5256C14.4998 13.3719 14.5512 13.2431 14.6541 13.1395C14.7569 13.0358 14.8846 12.9839 15.0371 12.9839C15.1896 12.9839 15.3187 13.0358 15.4245 13.1395C15.5302 13.2431 15.5831 13.3719 15.5831 13.5256V14.2435C15.5831 14.6186 15.4535 14.9357 15.1943 15.1947C14.9351 15.4538 14.6179 15.5833 14.2425 15.5833H5.75034ZM9.45817 5.49032L7.75144 7.19705C7.6414 7.30709 7.51507 7.36478 7.37244 7.37013C7.22982 7.37546 7.09749 7.32044 6.97546 7.20507C6.86138 7.08968 6.80568 6.96068 6.80836 6.81807C6.81102 6.67544 6.87005 6.54643 6.98542 6.43105L9.53509 3.8814C9.60474 3.8173 9.67798 3.76923 9.7548 3.73717C9.8316 3.70511 9.91466 3.68909 10.004 3.68909C10.0933 3.68909 10.1764 3.70511 10.2532 3.73717C10.33 3.76923 10.4004 3.8173 10.4645 3.8814L13.0142 6.43105C13.1243 6.54109 13.1819 6.66528 13.1873 6.80363C13.1926 6.94198 13.1383 7.06884 13.0242 7.18423C12.9021 7.29961 12.7712 7.35596 12.6312 7.3533C12.4913 7.35063 12.3636 7.2916 12.2482 7.17621L10.5415 5.49032V12.282C10.5415 12.4357 10.49 12.5645 10.3872 12.6681C10.2844 12.7718 10.1567 12.8237 10.0042 12.8237C9.85171 12.8237 9.72258 12.7718 9.61682 12.6681C9.51105 12.5645 9.45817 12.4357 9.45817 12.282V5.49032Z"
          }
        )
      )
    );
  }
);
export {
  UploadIcon
};
